/**
 * @generated SignedSource<<0a88be94d4059ddb97862f0469d81a17>>
 * @relayHash ef310b22345147cf3d255487224a101d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fff81462a25563df465a72a3fe72c26c1dfd48d918d862e2ecb9ed436d8ecb5d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type linkPickerResolversRequestFormsQuery$variables = {
  cloudId: string;
  helpCenterAri?: string | null | undefined;
  limit: number;
  queryTerm: string;
};
export type linkPickerResolversRequestFormsQuery$data = {
  readonly helpObjectStore_searchRequestTypes: {
    readonly results?: ReadonlyArray<{
      readonly displayLink: string;
      readonly iconUrl: string | null | undefined;
      readonly id: string;
      readonly title: string;
    }>;
  } | null | undefined;
};
export type linkPickerResolversRequestFormsQuery = {
  response: linkPickerResolversRequestFormsQuery$data;
  variables: linkPickerResolversRequestFormsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "queryTerm",
    "variableName": "queryTerm"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpObjectStoreRequestTypeSearchResult",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "displayLink"
        },
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreRequestTypeSearchResults"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "linkPickerResolversRequestFormsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "linkPickerResolversRequestFormsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "fff81462a25563df465a72a3fe72c26c1dfd48d918d862e2ecb9ed436d8ecb5d",
    "metadata": {},
    "name": "linkPickerResolversRequestFormsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d04dcc1d521812fbf731320b6a06a53e";

export default node;
